<template lang="pug">
.body-wrapper
    DisplacementImage(
        :width="512",
        aspectRatio="1:1",
        :image1="require('@/assets/images/featured-placeholder.jpg')",
        :image2="require('@/assets/images/featured-placeholder2.jpg')",
        :displacement="require('@/assets/images/displacement2.jpg')"
    )
</template>

<script>
import DisplacementImage from "@/components/displacement-image.vue";
export default {
    name: "playground",
    components: {
        DisplacementImage,
    },
};
</script>

<style lang="scss">
</style>